import { useEffect, useState } from 'react';
import { formatStartsIn } from '../utils/gameTicketStyles';

/**
 * useMatchupCountdown — the single shared "starts in" ticker for every matchup
 * surface (see docs/SPRINT8_WI1_DESIGN_SPEC.md §5). Updates once a minute so
 * the hero, lobby card, and any future variant show the *same* countdown for
 * the same game rather than each running its own interval.
 *
 * @param {string|null} startTime - ISO start time of the game.
 * @returns {string} human countdown, e.g. "Starts in 3h 12m".
 */
export function useMatchupCountdown(startTime) {
  const [startsIn, setStartsIn] = useState(() => formatStartsIn(startTime));

  useEffect(() => {
    setStartsIn(formatStartsIn(startTime));
    const id = setInterval(() => setStartsIn(formatStartsIn(startTime)), 60000);
    return () => clearInterval(id);
  }, [startTime]);

  return startsIn;
}

export default useMatchupCountdown;
